/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import { useQuery } from "@tanstack/react-query";
import { getUserInfo } from "./queryFunctions";
import { IUserInformation } from "@/interfaces/User.interface";

export const useUserInfo = (
  userId: string
) =>
  useQuery<IUserInformation, Error>({
    queryKey: ["user-info", userId],
    queryFn: () => getUserInfo(userId),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000 // 5 minutes
  });
